import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { UsuariosContextService } from "../../context/usuarios-context.service";
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { UsuariosService } from "../../services/usuarios.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'app-etiquetadores',
    templateUrl: './etiquetadores.component.html'
})
export class EtiquetadoresComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    private _filtersDropDown;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public etiquetadoresList;
    public etiquetadorId;
    public applicationUserId;
    public etiquetador;

    public denominaciones;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;

    public deleteModal = false;
    public newEditModal = false;
    public sendInvitationModal = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public disabledDenominacion: Subject<boolean> = new Subject();

    public refreshCheckbox_habilitado = false;

    public orderBy: string;
    public columnId: number;

    public toCloseSpinner = 0;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _usuariosService: UsuariosService,
        private readonly _dataProvider: DataProvider,
        private readonly _usuariosContext: UsuariosContextService,
        private readonly utilsService: UtilsService,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            pais: ['', Validators.required],
            denominacion: [{ value: '', disabled: true }],
            des: [''],
            userName: [''],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false'],
            habilitado: ['']
        });
        this._usuariosContext.etiquetadoresFilters = null;

        this.checkWarnings(this.filtersForm.get('pais').value);

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this._filtersDropDown = {
                    paisId: pais.id
                };

                this._spinnerService.showSpinner();
                this._usuariosService.getDenominaciones(this._filtersDropDown).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.denominaciones = resp.lista;
                        this.disabledDenominacion.next(false);
                    }
                });
            } else {
                this.denominaciones = null;
                this.disabledDenominacion.next(true);
                this.filtersForm.get('denominacion').reset();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
              this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.filtersForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes ? this._sessionContext.sessionUser.lsClaimTypes : "";
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    private checkWarnings(etiquetador) {
        if (etiquetador && this.filtersForm.valid) {
            this.filtersVisible = false;
            this.showWarning = false;
            this.mensajes = [];
            this.getEtiquetadores();
        } else {
            this.filtersVisible = true;
            this.showWarning = true;
            this.mensajes.push({ class: 'warning', message: 'global.info.filterRequired' });
        }
    }

    public pageChange(page) {
        this._usuariosContext.etiquetadoresFilters.numPagina = this.currentPage = page - 1;
        this.getEtiquetadores();
    }

    public itemsPerPageChange(items) {
        this._usuariosContext.etiquetadoresFilters.numPagina = this.currentPage = 0;
        this._usuariosContext.etiquetadoresFilters.tamPagina = this.itemsPerPage = items;
        this.getEtiquetadores();
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.mensajes = [];
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (this.filtersForm.get('denominacion').value ||
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            this.filtersForm.get('des').value ||
            this.filtersForm.get('userName').value ||
            !this.filtersForm.get('habilitado').pristine ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null,
            dateType: 'false'
        });
        this._filtersDropDown = null;
        this.disabledDenominacion.next(true);
        this.refreshCheckbox_habilitado = true;
        // this.filtersForm.get('dateType').patchValue('false');
    }

    public pristineCheckbox(idForm:string, pristine:boolean){
      const form = this.filtersForm.get(idForm);
      pristine ? form.markAsPristine() : form.markAsDirty();
    }

    public filtrar() {
        this.validDates();
        if (this.filtersForm.valid) {
            this.applyFilters();
        } else {
            this.showError = true;

            if (Object.keys(this.filtersForm.controls).some(key => this.filtersForm.get(key).hasError('required'))) {
                this.mensajes.push({ class: 'error', message: 'global.error.required' });
            }   
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this._usuariosContext.etiquetadoresFilters = {
            denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : '',
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : '',
            desEtiquetador: this.filtersForm.get('des').value ? this.filtersForm.get('des').value : '',
            userName: this.filtersForm.get('userName').value ? this.filtersForm.get('userName').value : '',
            cargaRegistroEnUso: true,
            activo: this.filtersForm.get('habilitado').value ? this.filtersForm.get('habilitado').value : null,
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this.getEtiquetadores();
    }

    public getEtiquetadores() {
        if (this._usuariosContext.etiquetadoresFilters) {
            this._filters = this._usuariosContext.etiquetadoresFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._usuariosService.getEtiquetadores(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.etiquetadoresList = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public create() {
        this.etiquetadorId = null;
        this.newEditModal = true;
    }

    public update(etiquetador) {
        this.etiquetadorId = etiquetador.etiquetadorId;
        this.applicationUserId = etiquetador.applicationUserId;
        this.newEditModal = true;
    }

    public block(etiquetador) {
        let etq = {
            userName: etiquetador.userName,
            activo: !etiquetador.activo
        };
        this._spinnerService.showSpinner();
        this._usuariosService.blockEtiquetador(etq).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (etiquetador.activo) {
                this.pushMessage('global.success.itemBlocked');
            } else {
                this.pushMessage('global.success.itemUnBlocked');
            }
            this.getEtiquetadores();
        });
    }

    public sendInvitation() {
        this.etiquetadorId = null;
        this.sendInvitationModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
        this.sendInvitationModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        this.sendInvitationModal = false;
        if (value) {
            this.getEtiquetadores();
        }
    }

    public pushMessage(mensaje) {
        this.mensajes = [];
        this.showError = true;
        this.mensajes.push({ class: 'success', message: mensaje });
    }

    public askDelete(etiquetador) {
        this.etiquetador = etiquetador;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._usuariosService.deleteEtiquetador(this.etiquetador.etiquetadorId, this.etiquetador.applicationUserId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getEtiquetadores();
        });
    }

    public getIcon(prop: string) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty.indexOf(prop) != -1) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
      this.columnId = idColumn;
      if (this.etiquetadoresList && this.etiquetadoresList.length > 0) {
        if (this._usuariosContext.etiquetadoresFilters) {
          this._filters = this._usuariosContext.etiquetadoresFilters;
          if (!this.orderBy || this.orderBy.includes('DESC')) {
            this.orderBy = 'ASC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: false
              }
            ];
          } else if (this.orderBy.includes('ASC')) {
            this.orderBy = 'DESC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: true
              }
            ];
          }
          this.getEtiquetadores();
        }
      }
    }

    private checkCloseSpinner() {
      this.toCloseSpinner -= 1;
      if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
      }
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._usuariosService.getDocHelp('Users_Packers.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }

    public trackByUserName(index: number, etiquetador: { userName: string }): string {
        return etiquetador.userName;
    }
}

